import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  Typography
} from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { logoutModelSx } from 'src/common/CommomSxs';
import {
  isLocalSeoUser,
  logoutFromApp
} from 'src/common/config/FunctionHelper';
import { removeLocalSeoAllStorage } from 'src/common/config/FunctionHelperPartTwo';
import {
  logoutLink,
  logoutLocalSeoLink,
  logoutText,
  logoutTitle,
  paths
} from 'src/common/config/TextMessage';
import { cleanupInitialState } from 'src/redux/counterSlice';
import { cleanupLocalSeoInitialState } from 'src/redux/localSeo';
import { cleanupKeywordInitialState } from 'src/redux/dashboard';
import { siteAuditCleanupInitialState } from 'src/redux/siteAuditReducer';
import { userCleanupInitialState } from 'src/redux/userReducer';
import { queryClient } from 'src/react-query/queryClient';

const LogoutModel = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLocalSeo = isLocalSeoUser();
  const handleLogout = () => {
    onClose();
  };

  const logout = async () => {
    setLoading(true);
    await logoutFromApp();
    // redirect to dashboard
    setTimeout(() => {
      setLoading(false);
      removeLocalSeoAllStorage();
      dispatch(cleanupInitialState());
      dispatch(userCleanupInitialState());
      dispatch(siteAuditCleanupInitialState());
      dispatch(cleanupLocalSeoInitialState());
      dispatch(cleanupKeywordInitialState());
      queryClient.clear();
      navigate(paths?.signin);
      window.open(isLocalSeo ? logoutLocalSeoLink : logoutLink, '_blank');
    }, 1000);
  };
  return (
    <Dialog
      open={open ?? false}
      onClose={handleLogout}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '400px'
        }
      }}
      disableScrollLock={true}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: '700 !important',
            fontSize: 'var(--font-size-20)',
            lineHeight: '27px',
            textAlign: 'center',
            color: 'var(--color-primary)',
            marginTop: '18px'
          }}
        >
          {logoutTitle}
        </Typography>
      </DialogTitle>
      <div className="px-9">
        <Box sx={logoutModelSx?.descSx}>{logoutText}</Box>
        <div
          className="flex  mb-7 mt-7 justify-center h-10"
          style={logoutModelSx?.btnBox}
        >
          <Button
            variant="outlined"
            //color="error"
            size="small"
            onClick={() => {
              handleLogout();
            }}
            fullWidth
            sx={logoutModelSx?.btnSx}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={loading}
            onClick={() => {
              logout();
            }}
            fullWidth
            sx={logoutModelSx?.btnSx}
          >
            {' '}
            {loading ? <CircularProgress size={24} /> : 'Log Out'}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
export default LogoutModel;
